import { Form, Input, Modal, Select, notification } from "antd";
import { useMutation } from "urql";

import { graphql } from "@/__graphql__";

interface UpdateContactPersonModalProps {
  initialValues: {
    contactPersonId: string;
    name: string;
    emailAddresses?: string[] | null;
    phoneNumbers?: string[] | null;
  };
  open: boolean;
  onClose: () => void;
}

interface UpdateContactPersonModalFormValues {
  name: string;
  emailAddresses?: string[];
  phoneNumbers?: string[];
}

const UpdateContactPersonMutation = graphql(`
  mutation Dashboard__ContactPersonsSection__UpdateContactPersonMutation($input: UpdateContactPersonInput!) {
    updateContactPerson(input: $input) {
      contactPerson {
        id
        name
        emailAddresses
        phoneNumbers
      }
    }
  }
`);

export default function UpdateContactPersonModal({ initialValues, open, onClose }: UpdateContactPersonModalProps) {
  const [form] = Form.useForm<UpdateContactPersonModalFormValues>();

  const [{ fetching: isUpdating }, updateContactPerson] = useMutation(UpdateContactPersonMutation);

  const handleOnSubmit = async (values: UpdateContactPersonModalFormValues) => {
    try {
      await updateContactPerson({
        input: {
          contactPersonId: initialValues.contactPersonId,
          name: values.name,
          emailAddresses: values.emailAddresses ?? [],
          phoneNumbers: values.phoneNumbers ?? [],
        },
      });

      onClose();
    } catch {
      notification.error({ title: "Er ging iets mis bij het bijwerken van de contactpersoon." });
    }
  };

  return (
    <Modal
      centered
      confirmLoading={isUpdating}
      onCancel={onClose}
      onOk={() => form.submit()}
      open={open}
      title={initialValues.name}
    >
      <Form form={form} initialValues={initialValues} onFinish={handleOnSubmit} layout="vertical">
        <Form.Item label="Naam" name="name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="E-mail adressen" name="emailAddresses">
          <Select mode="tags" open={false} placeholder="Typ een e-mailadres en druk op enter" />
        </Form.Item>
        <Form.Item label="Telefoonnummers" name="phoneNumbers">
          <Select mode="tags" open={false} placeholder="Typ een telefoonnummer en druk op enter" />
        </Form.Item>
      </Form>
    </Modal>
  );
}
